import React from 'react';

const Divider = (props) => {
    return (<hr className="divider" {...props}></hr>);
};

export default Divider;



// WEBPACK FOOTER //
// ./src/components/common/divider.js